import React, { useRef, useState } from "react";
import { _otpFor } from "../../utils/Constant";
import { apiRequest } from "../../utils/config/apiRequest";
import { apiUrl } from "../../utils/endPoints/apiUrl";

const Emailotp = ({ formik, otpToken, setSideBarState, setOtpToken }) => {
  const [emailOtp, setEmailOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const updatedOtp = [...emailOtp];
      updatedOtp[index] = value;
      setEmailOtp(updatedOtp);

      // Auto focus next input if a digit is entered
      if (value && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !emailOtp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        otp: emailOtp.join(""),
        otpFor: _otpFor.USER_REGISTRATION,
        otpToken: otpToken.email
      };
      const { data, status, message } = await apiRequest({
        endUrl: apiUrl.verifyotp,
        method: 'POST',
        body: payload,
        showMsg: true
      });
      if (status) {
        setOtpToken((prev) => ({
          ...prev,
          email: data.verifiedOtpToken,
        }));
        setSideBarState((prev) => ({
          ...prev,
          aboutCompany: { isCompleted: true, isActive: false },
          aboutYou: { isCompleted: true, isActive: false },
          mobileOtp: { isCompleted: true, isActive: false },
          emailOtp: { isCompleted: true, isActive: false },
          setPassword: { isCompleted: false, isActive: true },
        }));
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  };
  return (
    <div className="col-sm-12 col-md-6">
      <div className="loginTabs">
        <div className=" verify-head">
          <div className="text-center otp-logo-head">
            <img height="200px" src="/images/email-logo-otp.png" alt="/" />
          </div>
          <h4 className="mb-3 text-center">Verify your email address</h4>
          <p className="text-center mb-0">
            An email with verification code has been sent to "{formik.values.email}"
          </p>
          <p className="text-center">Please enter the code here:</p>
          <form onSubmit={handleSubmit}>

            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="email-id"
                role="tabpanel"
                aria-labelledby="org-tab"
              >
                <div className="row mt-6">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <div className="d-flex justify-content-center otp-input">
                        {emailOtp.map((digit, index) => (
                          <input
                            key={index}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleChange(e.target.value, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                            className="otp-box"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <p className="text-center mt-4 f-14">
                      <a href="#">Resend email</a>
                    </p>
                  </div>

                  <div className="col-md-12">
                    <button className="btn btn-dark login-btn mt-4">
                      Verify your email
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default Emailotp;
